import React from 'react';
import {getElementOffset} from "../../tools/index";
import DownloadBlock from "../../commonUI/DownloadBlock";
import {currentLocale, getString} from "../../index";
import CommonQuestionModal from "../../components/CommonQuestionModal";
import {App} from "../../App";
import css from "./index.module.less";
import Constant from "../../utils/Constant";
import {isiOS} from "../../utils";


export function DownloadPhoneView() {
    const [modalVisible, setModalVisible] = React.useState(false);
    const [modalHeight, setModalHeight] = React.useState(795);

    React.useEffect(() => {
        const ele = document.getElementById("modalBottomLine");
        const eleOffset = getElementOffset(ele);
        const documentHeight = document.body.clientHeight;

        setModalHeight(documentHeight - eleOffset.top)
    }, []);

    const allDownloadUrl = {
        ios: {
            appStore: {
                "en-US": "https://apps.apple.com/us/app/google-authenticator/id388497605",
                "zh-TW": "https://apps.apple.com/tw/app/google-authenticator/id388497605",
                "zh-CN": "https://apps.apple.com/zh/app/google-authenticator/id388497605",
            }
        },

    };
    const appStoreUrl = allDownloadUrl.ios.appStore[currentLocale] || allDownloadUrl.ios.appStore["en-US"];
    return (
        <App hideHeader={true}>
            <div className="App">
                <div className={css.title}>
                    {getString("slogan_2fa")}
                </div>

                <div className={css.downloadArea}>
                    <DownloadBlock
                        title={getString("slogan_2fa")}
                        subTitle={isiOS() ? getString("download_item_desc_2fa") : getString("download_android_item_desc")}
                        downloadUrl={isiOS() ? appStoreUrl : `https://static.webjiaoxue.cn/apk/authenticator.apk`}
                        onClick={() => {
                            if (isiOS()) {
                                setModalVisible(true);
                            }
                        }}
                    />
                </div>
                <div id="modalBottomLine"/>

                <div className="bottomWrap">
                    <img
                        style={{width: "100%", height: "100%"}}
                        src={require("../../images/app&web_pic_cut.png")}
                        alt="app&web_pic_cut"
                    />
                </div>

                <CommonQuestionModal
                    modalVisible={modalVisible}
                    setModalVisible={setModalVisible}
                    modalHeight={modalHeight}
                />

            </div>
        </App>
    );
}
